import { ComponentType } from "react";
import { Box } from "@mui/material";

type ResponsiveProps = {
  /** Rendered from the md breakpoint up. */
  Large: ComponentType;
  /** Rendered below the md breakpoint. */
  Small: ComponentType;
};

export function Responsive({ Large, Small }: ResponsiveProps) {
  return (
    <Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <Large />
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Small />
      </Box>
    </Box>
  );
}
